<template>
	<div class="d-flex align-center" style="width: 100%;">
		<div
			v-if="menuOpen"
			style="position: fixed;height: 100vh;width:100vw;top:0;left:0;z-index: 8;background-color: rgba(0,0,0,0.2);"
			@click="menuOpen = false"
			></div>
		<v-menu
			v-model="menuOpen"
			bottom
			offset-y
			left
			min-width="700"
			max-width="700"
			content-class="container-notification-menu-header"
			:close-on-content-click="false"
			:close-on-click="false"
			@input="changeMenu"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					outlined
					dark
					small
					block
					color="#959595"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon dark>mdi-cog-outline</v-icon>
					<p class="ml-1 mb-0">Configuración</p>
				</v-btn>
			</template>
			<div class="white" style="position: relative;">
				<v-btn
					icon
					dark
					x-small
					color="white"
					style="position:absolute;top: 5px; right: 5px;z-index: 9999;"
					@click="changeMenu(false)"
				>
					<v-icon dark>mdi-close</v-icon>
				</v-btn>
				<v-tabs
					v-model="tab"
					background-color="#524D4D"
					grow
					dark
					height="40"
				>
					<v-tab><p class="mb-0 caption">Impuestos</p></v-tab>
					<v-tab><p class="mb-0 caption">Proyectos / Especialidades</p></v-tab>
				</v-tabs>
				<v-tabs-items v-model="tab">
					<v-tab-item>
						<div>
							<div class="d-flex flex-row align-center justify-space-between my-2 mb-0 px-4">
								<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Impuestos</p>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon color="grey" class="mr-3"
													v-bind="attrs"
													v-on="on"
													small
													@click="startEditTax(null)">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>
									<span>Nuevo Impuesto</span>
								</v-tooltip>
							</div>
							<v-divider class="my-2"></v-divider>
							<v-list class="pt-0" style="max-height: 300px;overflow: scroll;">
								<v-list-item
									v-for="(tax, i) in taxOptions"
									:key="i"
									class="px-0 py-0"
								>
									<div style="width: 100%">
										<div class="d-flex flex-row px-4 justify-space-between">
											<div class="px-4 caption">
												<div class="d-flex align-center justify-space-between mr-4" style="width: 140px;">
													<p class="mb-0 mr-2">{{tax.name}}:</p>
													<p class="mb-0 font-weight-bold">{{tax.value}}%</p>
												</div>
											</div>
											<div>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															dark
															x-small
															color="warning"
															@click.stop="startEditTax(tax)"
															v-bind="attrs"
															v-on="on"
														>
															<v-icon small dark>mdi-pencil</v-icon>
														</v-btn>
													</template>
													<span>Editar Impuesto</span>
												</v-tooltip>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															dark
															x-small
															color="error"
															@click.stop="deleteTax(tax)"
															v-bind="attrs"
															v-on="on"
														>
															<v-icon small dark>mdi-delete-outline</v-icon>
														</v-btn>
													</template>
													<span>Eliminar Impuesto</span>
												</v-tooltip>
											</div>
										</div>
									</div>
								</v-list-item>
							</v-list>
						</div>
					</v-tab-item>
					<v-tab-item>
						<div>
							<div class="d-flex flex-row align-center justify-space-between my-2 mb-0 px-4">
								<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Proyectos / Especialidades</p>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon color="grey" class="mr-3"
											v-bind="attrs"
											v-on="on"
											small
											v-if="$checkPermissions(['create_company_project_specialties'])"
											@click="setCostCategory(null)">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>
									<span>Nueva Especialidad</span>
								</v-tooltip>
							</div>
							<v-divider class="my-2"></v-divider>
							<v-list class="pt-0" style="max-height: 300px;overflow: scroll;">
								<v-list-item
									v-for="(item, i) in costSpecialties"
									:key="i"
									class="px-0 py-0"
								>
									<div style="width: 100%">
										<div class="d-flex flex-row px-4 justify-space-between">
											<div class="px-4 caption">
												<p class="mb-0 caption font-weight-bold" style="color: #707070;">{{ item.name }}</p>
											</div>
											<div>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															dark
															x-small
															color="warning"
															v-if="$checkPermissions(['create_company_project_specialties'])"
															@click="setCostCategory(item)"
															v-bind="attrs"
															v-on="on"
														>
															<v-icon small dark>mdi-pencil</v-icon>
														</v-btn>
													</template>
													<span>Editar Especialidad</span>
												</v-tooltip>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															dark
															x-small
															color="error"
															v-if="$checkPermissions(['delete_company_project_specialties'])"
															@click="deleteCategory(item)"
															v-bind="attrs"
															v-on="on"
														>
															<v-icon small dark>mdi-delete-outline</v-icon>
														</v-btn>
													</template>
													<span>Eliminar Especialidad</span>
												</v-tooltip>
											</div>
										</div>
									</div>
								</v-list-item>
							</v-list>
						</div>
					</v-tab-item>
				</v-tabs-items>
			</div>
			<v-divider class="mx-2"></v-divider>
		</v-menu>
	</div>
</template>

<script>
// import _debounce from 'lodash/debounce'
import {deleteCostSpecialtyCompany, deleteCostSubCategoryCompany, deleteCostItemCompany} from '@/helpers/api/costs'
import {deleteTaxOption} from '@/helpers/api/general'
// import {createSpecialty, updateSpecialty, deleteSpecialty, getSpecialties} from '@/helpers/api/company'

export default {
  name: 'CostBreakdownCompanySettings',
	components: {},
  data: () => ({
		selectedTax: 0.19,
		menuOpen: false,
		selectedCostCategoryId: null,
		selectedCostSubCategoryId: null,
		tab: null,
    validform: true,
		loadingData: false,
    newBudgetConcept: {
			budget_concept_id: null,
			name: null
    },
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		taxOptions(){
			return this.$store.state.general.taxesOptions
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		companySpecialties(){
			return this.$store.state.costbreakdown.companiesSpecialties
		},
		costSpecialties(){
			return this.$store.state.costbreakdown.companiesCostSpecialties
		},
		costSubCategories(){
			if(this.selectedCostCategoryId){
				const subcategories = this.costCategories.find(item => item.id === this.selectedCostCategoryId)
				return subcategories ? subcategories.subcategories : []
			}
			return []
		},
		costGeneralSubCategories(){
			return this.$store.state.costbreakdown.companiesCostGeneralSubCategories
		},
		costItems(){
			if(this.costSubCategories && this.selectedCostSubCategoryId){
				let costs = this.costSubCategories.find(item => item.id === this.selectedCostSubCategoryId)
				if(!costs){
					costs = this.costGeneralSubCategories.find(item => item.id === this.selectedCostSubCategoryId)
				}
				return costs ? costs.items : []
			}
			return []
		}
  },
	watch: {
		// selectedTax(newValue){
		// 	if(newValue){

		// 	}
		// },
		selectedCompany(newValue){
			if(newValue){
				this.$store.dispatch('costbreakdown/getCompanySpecialties')
				this.$store.dispatch('costbreakdown/getCompanyCostItems')
				this.$store.dispatch('costbreakdown/getCompanyCostSpecialties')
			}
		},
	},
  mounted(){
		if(this.$store.state.budget.newBudgetConceptModalEditing){
			this.newBudgetConcept = this.$store.state.budget.newBudgetConceptModalEditing
		}
		if(this.selectedCompany){
			this.$store.dispatch('costbreakdown/getCompanySpecialties')
			this.$store.dispatch('costbreakdown/getCompanyCostItems')
			this.$store.dispatch('costbreakdown/getCompanyCostSpecialties')
		}
  },
  methods: {
		startEditTax(item){
			let modalData = item
			if(modalData){
				modalData = {...modalData, ...{company_tax_id: item.id}}
			}
			this.$store.commit('general/setTaxesOptionsModalEditting', modalData)
			this.$store.commit('general/setTaxesOptionsModal', true)
		},
		async deleteTax(item){
			if(item){
				const data = {company_tax_id: item.id}
				await deleteTaxOption(data)
				this.$store.dispatch('general/getTaxesOptions')
			}
		},
		setSelectedCostCategory(item){
			this.selectedCostCategoryId = item.id
			this.tab = 1
		},
		setSelectedCostSubCategory(item){
			console.log('item', item)
			// this.selectedCostSubCategoryId = item.id
			// this.tab = 2
		},
		changeMenu(value){
			this.menuOpen = value
		},
		setCostCategory(item){
			this.$store.commit('costbreakdown/setNewCostBreakdownCategoryModal', true)
			if(item){
				this.$store.commit('costbreakdown/setNewCostBreakdownCategoryModalEditing', {...item, ...{company_cost_category_id: item.id}})
			}
		},
		setCostSubCategory(item){
			this.$store.commit('costbreakdown/setNewCostBreakdownSubCategoryModal', true)
			let data = {company_cost_category_id: this.selectedCostCategoryId}
			if(item){
				data = {...data, ...item, ...{company_cost_subcategory_id: item.id}}
			}
			this.$store.commit('costbreakdown/setNewCostBreakdownSubCategoryModalEditing', data)
		},
		setCostConcept(item){
			this.$store.commit('costbreakdown/setNewCostBreakdownItemModal', true)
			let data = {company_cost_subcategory_id: this.selectedCostSubCategoryId}
			if(item){
				data = {...data, ...item, ...{company_cost_item_id: item.id}}
			}
			this.$store.commit('costbreakdown/setNewCostBreakdownItemModalEditing', data)
		},
		async deleteCategory(item){
			await deleteCostSpecialtyCompany({company_cost_category_id: item.id})
			this.$store.dispatch('costbreakdown/getCompanyCostSpecialties')
		},
		async deleteSubcategory(item){
			await deleteCostSubCategoryCompany({company_cost_subcategory_id: item.id})
			this.$store.dispatch('costbreakdown/getCompanyCostItems')
		},
		async deleteConcept(item){
			await deleteCostItemCompany({company_cost_item_id: item.id})
			this.$store.dispatch('costbreakdown/getCompanyCostItems')
		},
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
	.handle_drag{
		cursor: move;
	}
	.selected{background-color: #ececec;}
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>